import { createAsyncThunk } from '@reduxjs/toolkit';
import { IdentityOemMapping } from 'common/types/Entities';

import { APIIdentitiesByIdGetList } from './Identities.api';

export const fetchIdentitiesById = createAsyncThunk(
    'identities/fetchIdentitiesById',
    async (params: { userId: string; noCache?: boolean }) => {
        const response = await APIIdentitiesByIdGetList(params);
        return sortIdps(response.data);
    }
);

const sortIdps = (idpsList: IdentityOemMapping[]) => idpsList.slice().sort((a, b) => {
    if (a.oemIdPId === import.meta.env.VITE_OEM_IDP_ID) {
        return 1;
    }
    if (a === b) {
        return 0;
    }
    return -1;
});
